import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React from "react";

export const TvShowNotFound = () => (
  <Grid item xs={12}>
    <Typography variant="body2" color="textSecondary" component="p">
      TvShowNotFound
    </Typography>
  </Grid>
);
